<section id="wrapper">
    <div class="login-register animated fadeIn fast"
        style="background-color: lightgray;">

        <h1 class="text-center">Cambiar Contraseña</h1>

        <div class="login-box card shadow p-3 mb-5 bg-white rounded">
            <div class="card-body">

                <form [formGroup]="pswForm"
                    (ngSubmit)="enviar()"
                    autocomplete="off"
                    class="form-horizontal form-material"
                    id="loginform">
                    <p class="text-center db">
                        <img class="ml-4"
                            src="./assets/images/logo-icon.png"
                            alt="EnviaLog Logo" />
                        <img src="./assets/images/logo-text.png"
                            alt="InnovaCen Logo" />
                    </p>

                    <h2 class="mt-2 ml-2 text-secondary"><i class="fa-solid fa-user mr-2"></i>
                        <span class="ml-2">{{usuario.nombre}}</span>
                    </h2>

                    <!-- password -->
                    <div class="form-group"
                        [ngClass]="{ 'has-danger': enviado && f['password'].errors }">

                        <div class="col-xs-12">
                            <div class="input-group">
                                <div class="input-group-addon"><i class="fa-solid fa-key"></i></div>
                                <input formControlName="password"
                                    class="form-control my-input"
                                    type="password"
                                    required=""
                                    placeholder="Contraseña"
                                    [ngClass]="{ 'form-control-danger': enviado && f['password'].errors }"
                                    [readonly]="imposible">
                            </div>
                            <div *ngIf="enviado && f['password'].errors"
                                class="form-control-feedback">
                                <div *ngIf="f['password'].errors['required']">Obligatorio</div>
                                <div *ngIf="pswForm.get('password')?.errors?.['apiError']">{{
                                    pswForm.get('password')?.errors?.['apiError'] }}</div>
                            </div>
                        </div>
                    </div>


                    <!-- password2 -->
                    <div class="form-group"
                        [ngClass]="{ 'has-danger': enviado && f['password2'].errors }">
                        <div class="col-xs-12">
                            <div class="input-group">
                                <div class="input-group-addon"><i class="fa-solid fa-key"></i></div>
                                <input formControlName="password2"
                                    class="form-control my-input"
                                    type="password"
                                    required=""
                                    placeholder="Confirmar Contraseña"
                                    [ngClass]="{ 'form-control-danger': enviado && f['password2'].errors }"
                                    [readonly]="imposible">
                            </div>
                            <div *ngIf="enviado && f['password2'].errors"
                                class="form-control-feedback">
                                <div *ngIf="f['password2'].errors['required']">Obligatorio</div>
                                <div *ngIf="pswForm.get('password2')?.errors?.['apiError']">{{
                                    pswForm.get('password2')?.errors?.['apiError'] }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="form-group text-center m-t-20">
                        <div class="col-xs-12">
                            <button class="btn btn-info btn-lg btn-block text-uppercase btn-rounded"
                                type="submit"
                                [disabled]="imposible || loading">
                                <i *ngIf="loading"
                                    class="fa fa-spinner fa-spin"></i>
                                Enviar
                            </button>
                        </div>
                    </div>

                    <div class="form-group text-center m-t-20">
                        <div class="col-xs-12">
                            <button class="btn btn-secondary btn-lg btn-block text-uppercase btn-rounded"
                                type="button"
                                (click)="cancelar()">
                                Cancelar
                            </button>
                        </div>
                    </div>

                </form>

            </div>
        </div>
    </div>
</section>